import { useAuth } from "@/context/AuthContext";
import { Menu, X, PlusCircle } from "lucide-react"; // Added PlusCircle
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button"; // Added Button
import { useListingFormContext } from "@/context/ListingFormContext"; // Import useListingFormContext

// import AuthButtons from "./navbar/AuthButtons";
import Logo from "./navbar/Logo";
import MobileMenu from "./navbar/MobileMenu";
import NavLinks from "./navbar/NavLinks";
import UserProfileDropdown from "./navbar/UserProfileDropdown";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();
  const { clearAllListingData } = useListingFormContext(); // Use the context
  // const location = useLocation(); // Not directly used in this logic
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 w-full transition-all duration-300 backdrop-blur-sm bg-white/95">
      <div className="w-full max-w-7xl mx-auto lg:max-w-none lg:mx-0 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo and primary navigation */}
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Logo />
            </div>

            {/* Desktop Navigation Links */}
            <div className="hidden sm:ml-10 sm:flex items-center space-x-4">
              <NavLinks />
            </div>
          </div>

          {/* CTA and mobile menu button */}
          <div className="flex items-center">
            {isAuthenticated ? (
              <>
                {/* Post Ad Button - Visible when authenticated */}
                <div className="hidden md:flex items-center mr-3">
                  <Button
                    onClick={() => {
                      clearAllListingData(); // Clear local storage
                      navigate("/dashboard/add-listing");
                    }}
                    variant="default"
                    className="bg-propertylk-blue hover:bg-propertylk-blue/90 text-white"
                  >
                    <PlusCircle className="h-5 w-5 mr-2" />
                    Post Ad
                  </Button>
                </div>
                <div className="hidden md:flex items-center space-x-3">
                  <UserProfileDropdown
                    user={user!}
                    handleLogout={handleLogout}
                  />
                  {/* user will not be null if isAuthenticated is true */}
                </div>
              </>
            ) : (
              <></>
              // <AuthButtons />
            )}

            {/* Mobile menu button */}
            <div className="flex items-center sm:ml-6 md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-propertylk-blue hover:bg-gray-100 focus:outline-none transition duration-150 ease-in-out"
              >
                {isMenuOpen ? (
                  <X className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <Menu className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <MobileMenu
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        user={user}
        handleLogout={handleLogout}
      />
    </nav>
  );
};

export default Navbar;
